<template>
  <div class="fuel-funds__sidebar h-mobile-margin-top-24h-mobile-no-border-radius">
    <div class="fuel-funds__total-tag h-mobile-no-border-radius">
      <h3 class="h-big-dollar-sign">$</h3>
      <h1 class="fuel-funds__total">{{ totalAvailable }}</h1>
    </div>
    <div class="fuel-funds__available">
      <h2 class="fuel-funds__available--text">Available</h2>
    </div>
    <div class="fuel-funds__terms h-center-align">
      <span class="h-italic-text h-helper-text"><a @click.stop="activateModal">(Terms and Conditions)</a></span>
    </div>
    <hr class="h-mobile-medium-hidden">
    <FuelFundsVendors></FuelFundsVendors>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelFundsVendors from './FuelFundsVendors.vue';

  export default {
    name: 'FuelFundsSidebar',
    components: {
      FuelFundsVendors,
    },
    computed: {
      ...mapGetters('fuelFunds', ['totalAvailable']),
    },
    methods: {
      activateModal() {
        this.$store.dispatch('main/showModal', 'termsAndConditions');
      },
    },
  };
</script>

